export const to = promise => promise.then(data => [data, null]).catch(err => [{}, err]);
